import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { localCreateInitialObject, makeSelectObject, requestLocalChangeObjectField, requestObject } from '../../../../store/Object';
import {  requestObjects } from '../../../../store/Objects';
import { closeSideBar } from '../../../../store/sidebar';
import RequestReport, { DispatchPropsType, MapStateType } from '../organisms/Reports/templates/RequestReportTemplate';
import { getData } from '../../../../store/actions/whatsappReports.action';
import { IRequestReport, RequestReportFieldName } from '../../../../interface/whatsappReport';

const mapStateToProps = (state: IStateType) => ({
    data: state.whatsappReports,
    requestReport: makeSelectObject(Instances.whatsappRequestReports)(state) || {},
});

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    onChange: (fields: { name: RequestReportFieldName, value: any }) => dispatch(requestLocalChangeObjectField(Instances.whatsappRequestReports, fields)),
    setRequestReportState: (tempObj: IRequestReport) => dispatch(localCreateInitialObject(Instances.whatsappRequestReports, tempObj)),
    onLoad: () => dispatch(requestObjects(Instances.whatsappReports, undefined, { property: "reports" })),
    onLoadData: () => dispatch(getData()),
    onSave: (requestReportData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.whatsappRequestReports, undefined, undefined, 'POST', true, true, requestReportData, callback)),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(RequestReport));